import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query';
import api from '../api/main/api';
import bookmeapi from '../api/bookme/api';
import authReducer from '../features/auth/authSlice';
import bookingReducer from '../features/booking/bookingSlice';
import listingReducer from '../features/listing/listingSlice';
import toastReducer from '../features/toast/toastSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    booking: bookingReducer,
    listing: listingReducer,
    toast: toastReducer,
    [api.reducerPath]: api.reducer,
    [bookmeapi.reducerPath]: bookmeapi.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(api.middleware).concat(bookmeapi.middleware),
});

export default store;

setupListeners(store.dispatch);
